import { render, staticRenderFns } from "./bought-license.vue?vue&type=template&id=718bd391&scoped=true"
import script from "./bought-license.vue?vue&type=script&lang=js"
export * from "./bought-license.vue?vue&type=script&lang=js"
import style0 from "./bought-license.vue?vue&type=style&index=0&id=718bd391&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718bd391",
  null
  
)

export default component.exports